import type { PlayerId } from './ids';

export const DISPLAY_NAME_MIN_LENGTH = 2;
export const DISPLAY_NAME_MAX_LENGTH = 16;

/** Letters (including æ, ø, å), digits, spaces, hyphen and underscore. */
export const DISPLAY_NAME_PATTERN = /^[\p{L}\p{N} _-]+$/u;

/** What every client in a room knows about the other players. */
export interface RoomPlayerInfo {
  id: PlayerId;
  displayName: string;
}
